export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_replyEdit') || '返答填写',
    icon: 'el-icon-edit',
    menuType: 'reply',
    divided: true,
    allow: 'R',
  },
  {
    text: that.$l('menu_text_back') || '回退需求',
    icon: 'el-icon-refresh-left',
    menuType: 'back',
    allow: 'B',
  },
  {
    text: that.$l('menu_text_export') || '补货明细导出',
    icon: 'el-icon-right',
    menuType: 'export',
    divided: true,
    allow: 'E',
    data: { templateGroup: 'ecom-replenishmentPurchase' },
  },
]
